import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {NgModel} from "@angular/forms";

@Component({
    selector: 'app-percentage-input',
    templateUrl: './percentage-input.component.html',
    styleUrls: ['./percentage-input.component.scss'],
    standalone: false
})
export class PercentageInputComponent implements OnInit {

  @Input() data: string = null;
  @Input() label: string = "";
  @Input() description: string = "";
  @Input() placeholder: string = "";
  @Input() disabledFlag: boolean;
  @Input() required: boolean;
  @Input() showError: boolean = false;
  @Output() focusOut: EventEmitter<string> = new EventEmitter<string>();
  message: string = "";
  id: string = "";

  constructor() {}

  ngOnInit() {
    if(!this.data) {
      this.data = '0';
    }
    this.id = "weave-percentage" + Math.floor(Math.random() * 1000);
    this.message = this.label;
    if(this.message.length > 30 || this.message.length == 0) {
      this.message = "This field";
    }
  }

  onFocusOut() {
    this.showError = false;
    this.focusOut.emit(this.data);
  }
}
